/**
 * Which sidebar section owns the page you are on.
 *
 * Kept apart from Sidebar.jsx so it can be reasoned about — and tested —
 * without dragging in a component that opens a socket on import.
 *
 * The labour screens live under /builder/operations/labour for historical
 * reasons, and the sidebar matches a parent by substring as a fallback, so
 * Operations claimed every one of them. It stayed hidden while Workforce
 * listed all twenty as children and won on order; trimming that list to two
 * exposed it, and opening Wages from the Workforce dashboard jumped the
 * sidebar across to Operations.
 *
 * Ownership is stated here rather than inferred from the URL, because the URL
 * is the thing that is wrong and renaming the routes would break every link
 * anybody has bookmarked.
 */
export const WORKFORCE_PREFIXES = [
  '/builder/operations/labour',
  '/builder/hr/',
  '/builder/workforce'
];

export function ownedByWorkforce(selectedPath) {
  const path = String(selectedPath || '');
  return WORKFORCE_PREFIXES.some((prefix) => path.startsWith(prefix));
}
